var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm10 md10" },
        [
          _c(
            "FormFieldsContainer",
            { on: { resultadoBusqueda: _vm.filtroRequerimiento } },
            [
              _c(
                "v-flex",
                { attrs: { sm10: "", md10: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.requerimiento.label,
                              items: _vm.requermientoslist,
                              "item-text": "asigrequerimiento",
                              "item-value": "asigrequerimiento",
                              clearable: ""
                            },
                            on: { change: _vm.datos_requerimientos },
                            model: {
                              value: _vm.formFields.requerimiento.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.requerimiento,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.requerimiento.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _vm.length_FLOTA != 1
                            ? _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.flota.label,
                                  items: _vm.flotalist,
                                  "item-text": "asigcrm_flota",
                                  "item-value": "asigcrm_flota",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.formFields.flota.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.flota, "value", $$v)
                                  },
                                  expression: "formFields.flota.value"
                                }
                              })
                            : _vm._e(),
                          _vm.length_FLOTA == 1
                            ? _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.flota.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.flota.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.flota, "value", $$v)
                                  },
                                  expression: "formFields.flota.value"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _vm.length_RUT != 1
                            ? _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.rut.label,
                                  items: _vm.crm_rutlist,
                                  "item-text": "asigcrm_rutcli",
                                  "item-value": "asigcrm_rutcli",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.formFields.rut.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.rut, "value", $$v)
                                  },
                                  expression: "formFields.rut.value"
                                }
                              })
                            : _vm._e(),
                          _vm.length_RUT == 1
                            ? _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.rut.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.rut.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.rut, "value", $$v)
                                  },
                                  expression: "formFields.rut.value"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.TipoEquipo.label,
                              items: _vm.equiposlist,
                              "item-text": "tipoeqname",
                              "item-value": "tipoeqid",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.TipoEquipo.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.TipoEquipo,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.TipoEquipo.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.formFields.equiposerie.label,
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.equiposerie.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.equiposerie,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.equiposerie.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.formFields.simserie.label,
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.simserie.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.simserie, "value", $$v)
                              },
                              expression: "formFields.simserie.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.rack.label,
                              items: _vm.racklist,
                              "item-text": "moviserierack",
                              "item-value": "moviserierack",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.rack.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.rack, "value", $$v)
                              },
                              expression: "formFields.rack.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm3: "", md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.Bloque.label,
                              items: _vm.bloquelist,
                              "item-text": "moviseriebloque",
                              "item-value": "moviseriebloque",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.Bloque.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.Bloque, "value", $$v)
                              },
                              expression: "formFields.Bloque.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm3: "", md3: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleBuscarClick } },
                              [
                                _c("v-icon", [_vm._v("search")]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { on: { click: _vm.clearFilters } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticStyle: { "margin-right": "5px" },
                        attrs: { label: "Buscar...", "append-icon": "search" },
                        on: { input: _vm.searchData },
                        model: {
                          value: _vm.filtrobusquedagrilla,
                          callback: function($$v) {
                            _vm.filtrobusquedagrilla = $$v
                          },
                          expression: "filtrobusquedagrilla"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleModal", {
            attrs: {
              reporte_Seleccionado: _vm.reporteSeleccionado,
              serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
              tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado,
              serieactivanroSeleccionado: _vm.serieactivanroSeleccionado
            },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }